module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_6.e9afac9a.png";